const Divider = () => {
  return (
    <div className="container divider mx-auto">
      <div className="w-[100%-2rem] mx-auto border-b border-black opacity-40"/>
    </div>
  );
}

export default Divider;